// NEOLOHN HTML LOGO
const neolohnBlackSVG = '<img style="height: 40px; margin-top: 5px;" src="https://handbuch.neolohn.de/uploads/images/gallery/2025-10/neolohn-black.png">';

/**
 * Alle Email Templates müssen über folgende Felder haben
 * - Betreff
 * - Inhalt
 * - HTML (optional)
 * 
 * Wenn wir die Template strings (``) verwenden, müssen wir den Whitespace beachten.
 * Deshalb soll links kein Whitespace innerhalb des Strings verwendet werden,
 * da sonst der Email Text den gleichen Whitespace erhält und den Text verzerrt.
 */

// Dient gleichzeitig als Standard/Fallback für die im Unternehmen anpassbare Willkommensmail (WillkommensEmail).
const MitarbeiterAppInstallationEmail = {
    Betreff: 'Willkommen bei neolohn',
    Inhalt: `Willkommen bei der neolohn Mitarbeiter-App von neolohn!

Ihr Zugang wurde für die neolohn Mitarbeiter-App aktiviert.

Um die neolohn Mitarbeiter-App nutzen zu können, sollten sie eine separate Email mit einem Link zum Account Update erhalten haben.
Falls Sie diese nicht erhalten haben sollten, klicken Sie bitte trotzdem auf den folgenden Link und dann auf Passwort vergessen, um diese erneut zu erhalten.

Nach der Aktualisierung Ihres Accounts erreichen Sie die neolohn Mitarbeiter-App unter folgendem Link:
$$neolohnUrl$$/ma-app

Die Mitarbeiter-App befindet sich nicht im App-Store.
Wie Sie die Mitarbeiter-App als App auf Ihrem Handy installieren, zeigen wir Ihnen in den folgenden Videos:
- MA-App auf einem iPhone installieren: https://player.vimeo.com/video/859811524 
- MA-App auf einem Android Handy installieren: https://player.vimeo.com/video/859815424

Wie sie sich bei dem Zeiterfassungsterminal mit der App anmelden:
https://player.vimeo.com/video/859815783

Das twodoxx-Team wünscht angenehmes Arbeiten mit der neolohn Mitarbeiter-App!`,
    HTML: `<p>Willkommen bei der neolohn Mitarbeiter-App von neolohn!</p>
<p>Ihr Zugang wurde für die neolohn Mitarbeiter-App aktiviert.</p>
<p>Um die neolohn Mitarbeiter-App nutzen zu können, sollten sie eine separate Email mit einem Link zum Account Update erhalten haben.<br>
Falls Sie diese nicht erhalten haben sollten, klicken Sie bitte trotzdem auf den folgenden Link und dann auf Passwort vergessen, um diese erneut zu erhalten.</p>
<p>Nach der Aktualisierung Ihres Accounts erreichen Sie die neolohn Mitarbeiter-App unter folgendem Link:<br>
<a href="$$neolohnUrl$$/ma-app">$$neolohnUrl$$/ma-app</a></p>
<p>Die Mitarbeiter-App befindet sich nicht im App-Store.<br>
Wie Sie die Mitarbeiter-App als App auf Ihrem Handy installieren, zeigen wir Ihnen in den folgenden Videos:</p>
<ul>
<li>MA-App auf einem iPhone installieren: <a href="https://player.vimeo.com/video/859811524">https://player.vimeo.com/video/859811524</a></li>
<li>MA-App auf einem Android Handy installieren: <a href="https://player.vimeo.com/video/859815424">https://player.vimeo.com/video/859815424</a></li>
</ul>
<p>Wie sie sich bei dem Zeiterfassungsterminal mit der App anmelden:<br>
<a href="https://player.vimeo.com/video/859815783">https://player.vimeo.com/video/859815783</a></p>
<p>Das twodoxx-Team wünscht angenehmes Arbeiten mit der neolohn Mitarbeiter-App!</p>`,
};

const PersonalfragebogenEmail = {
    Betreff: 'Für Ihre Bewerbung: Personalfragebogen',
    Inhalt: `Liebe/r Bewerber/in,

vielen Dank für Ihre Registrierung im Bewerbungsportal!

Den Link zu Ihrem Personalfragebogen finden Sie hier:
$$neolohnUrl$$/bewerbung/personalfragebogen/$$bewerberID$$ 

Um sich Anzumelden, geben Sie bitte auch folgenden PIN ein:

$$bewerberPIN$$

Viel Erfolg!
    `,
    HTML: `
    <html>
      <head>
        <style>
          h1 {
            color: #00548f;
            font-size: 18px;
          }
          p {
            font-size: 16px;
            line-height: 1.5;
          }
        </style>
      </head>
      <body>
      <div style="font-family: Arial, sans-serif; margin: 10px;">
        <h1>Vielen Dank für Ihre Registrierung im Bewerbungsportal!</h1>
        <p>Den Link zu Ihrem Personalfragebogen finden Sie <a href="$$neolohnUrl$$/bewerbung/personalfragebogen/$$bewerberID$$">hier</a>:</p>
        <p><a style="word-wrap: break-word;" href="$$neolohnUrl$$/bewerbung/personalfragebogen/$$bewerberID$$">$$neolohnUrl$$/bewerbung/personalfragebogen/$$bewerberID$$</a></p>

        <p>Um sich Anzumelden, geben Sie bitte auch folgenden PIN ein:</p>

        <div style="font-size: 20px;
            color: #00548f;
            background-color: #d9eaf5;
            border: 1px solid #ddd;
            padding: 10px;
            margin: 10px;
            text-align: center;
            font-weight: bold;">$$bewerberPIN$$</div>

        <p>Viel Erfolg!</p>

        <p style="font-size: 10px;">Dies ist eine automatische Benachrichtigung von neolohn. Bitte nicht direkt auf diese E-Mail antworten.</p>
      </div>
    </body>
  </html>`
};

const PersonalfragebogenEingereicht = {
    Betreff: 'Bestätigung: Personalfragebogen eingereicht',
    Inhalt: `Liebe/r Bewerber/in,

vielen Dank für das Einreichen Ihres Personalfragebogens!
Ihr potentieller Arbeitgeber kann nun Ihren ausgefüllten Personalfragebogen einsehen und bearbeiten.

Sie können weiterhin den Personalfragebogen einsehen, aber keine Änderungen mehr tätigen.

Bei keiner Überahme der Daten werden diese automatisch unwideruflich gelöscht.

Viel Erfolg!

--------
Dies ist eine automatische Benachrichtigung von neolohn.  
Bitte nicht direkt auf diese E-Mail antworten.
    `
};

const dienstplanEmailStyle = `
<style>
    body {
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
      background-color: #f4f4f4;
      display: flex;
      justify-content: center;
    }
    .container {
      max-width: 600px;
      margin: 5px;
      background: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
    .header {
      background-color: #273E69;
      color: white;
      padding: 20px;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
    }
    .content {
      padding: 10px;
      font-size: 12px;
      color: #333333;
      line-height: 1.5;
    }
    .changes {
      margin: 20px 0;
      border-collapse: collapse;
      width: 100%;
    }
    .changes th, .changes td {
      border: 1px solid #dddddd;
      padding: 6px;
      text-align: left;
    }
    .changes th {
      background-color: #f1f5f9;
      font-weight: bold;
    }
    .button {
      display: inline-block;
      padding: 12px 20px;
      background-color: #273E69;
      color: white !important;
      text-decoration: none;
      border-radius: 6px;
      font-weight: bold;
    }
    .footer {
      text-align: center;
      font-size: 10px;
      color: #888888;
      padding: 10px;
      background: #f9fafb;
    }
  </style>
`;

/**
 * Email für Dienstplan Änderungen
 * Variablen:
 * - $$rows$$ muss befüllt werden mit Tabellenzeilen der Änderungen
 * - $$neolohnUrl$$ die baseUrl mit der Kundennummer
 */
const DienstplanAenderungEmail = {
  Betreff: 'Änderungen in deinem Dienstplan',
  Inhalt: `
Hallo $$mitarbeiterName$$,

es gibt folgende Änderungen in deinem Dienstplan:  

$$rows$$

Bitte überprüfe die Änderung in deiner App:
$$neolohnUrl$$/ma-app/wochenplan
  `,
  HTML: `
  <!DOCTYPE html>
<html lang="de">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Planänderung</title>
  ${dienstplanEmailStyle}
</head>
<body>
  <div class="container">
    <div class="header">
      📅 Planänderung in deinem Dienstplan
    </div>
    <div class="content">
      <p>Hallo <strong>$$mitarbeiterName$$</strong>,</p>
      <p>es gibt eine Änderung in deinem Dienstplan:</p>

      <table class="changes">
        <tr>
          <th>Datum</th>
          <th>Titel</th>
          <th>Posten</th>
          <th>Alter Dienst</th>
        </tr>
      $$rows$$
      </table>

      <p>Bitte überprüfe deinen Dienstplan in der neolohn-App:</p>
      <div style="text-align: center; margin-top: 20px;"><a href="$$neolohnUrl$$/ma-app/wochenplan" class="button">Dienstplan öffnen</a></div>
    </div>
    <div class="footer">
      Dies ist eine automatische Benachrichtigung deiner neolohn-App.  
      Bitte nicht direkt auf diese E-Mail antworten.
      <br>
      ${neolohnBlackSVG}
    </div>
  </div>
</body>
</html>
  `
};
/**
 * Email für Dienstplan Neu
 * Variablen:
 * - $$rows$$ muss befüllt werden mit Tabellenzeilen der neuen Schichten
 * - $$neolohnUrl$$ die baseUrl mit der Kundennummer
 */
const DienstplanNeuEmail = {
  Betreff: 'Neuigkeiten in deinem Dienstplan',
  Inhalt: `
Hallo $$mitarbeiterName$$,

es gibt folgende neue Schichten in deinem Dienstplan:  

$$rows$$

Bitte überprüfe deinen Dienstplan in deiner App:
$$neolohnUrl$$/ma-app/wochenplan
  `,
  HTML: `
  <!DOCTYPE html>
<html lang="de">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Planänderung</title>
  ${dienstplanEmailStyle}
</head>
<body>
  <div class="container">
    <div class="header">
      🆕 Neuigkeiten in deinem Dienstplan
    </div>
    <div class="content">
      <p>Hallo <strong>$$mitarbeiterName$$</strong>,</p>
      <p>es gibt Neuigkeiten in deinem Dienstplan:</p>

      <table class="changes">
        <tr>
          <th>Datum</th>
          <th>Titel</th>
          <th>Posten</th>
        </tr>
        $$rows$$
      </table>

      <p>Bitte überprüfe deinen Dienstplan in der neolohn-App:</p>
      <div style="text-align: center; margin-top: 20px;"><a href="$$neolohnUrl$$/ma-app/wochenplan" class="button">Dienstplan öffnen</a></div>
    </div>
    <div class="footer">
      Dies ist eine automatische Benachrichtigung deiner neolohn-App.  
      Bitte nicht direkt auf diese E-Mail antworten.
      <br>
      ${neolohnBlackSVG}
    </div>
  </div>
</body>
</html>
  `
};
/**
 * Email für Dienstplan Entfernung
 * Variablen:
 * - $$rows$$ muss befüllt werden mit Tabellenzeilen der neuen Schichten
 * - $$neolohnUrl$$ die baseUrl mit der Kundennummer
 */
const DienstplanEntferntEmail = {
  Betreff: 'Entfernung aus deinem Dienstplan',
  Inhalt: `
Hallo $$mitarbeiterName$$,

die folgende Schicht wurde aus deinem Dienstplan gelöscht:  

$$rows$$

Bitte überprüfe deinen Dienstplan in deiner App:
$$neolohnUrl$$/ma-app/wochenplan
  `,
  HTML: `
  <!DOCTYPE html>
<html lang="de">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Planänderung</title>
  ${dienstplanEmailStyle}
</head>
<body>
  <div class="container">
    <div class="header">
      ❌ Entfernung aus deinem Dienstplan
    </div>
    <div class="content">
      <p>Hallo <strong>$$mitarbeiterName$$</strong>,</p>
      <p>die folgende Schicht wurde aus deinem Dienstplan gelöscht:</p>

      <table class="changes">
        <tr>
          <th>Datum</th>
          <th>Titel</th>
          <th>Posten</th>
        </tr>
        $$rows$$
      </table>

      <p>Bitte überprüfe deinen Dienstplan in der neolohn-App:</p>
      <div style="text-align: center; margin-top: 20px;"><a href="$$neolohnUrl$$/ma-app/wochenplan" class="button">Dienstplan öffnen</a></div>
    </div>
    <div class="footer">
      Dies ist eine automatische Benachrichtigung deiner neolohn-App.  
      Bitte nicht direkt auf diese E-Mail antworten.
      <br>
      ${neolohnBlackSVG}
    </div>
  </div>
</body>
</html>
  `
};



export {
    MitarbeiterAppInstallationEmail,
    PersonalfragebogenEmail,
    PersonalfragebogenEingereicht,
    DienstplanAenderungEmail,
    DienstplanNeuEmail,
    DienstplanEntferntEmail
};